import React from 'react';
import Paper from 'material-ui/Paper';
import More from './more';
import Qty from './qty';
import OrderProps from './order-props';
import ItemMore from './item-more';
import ConfirmedDelivDate  from './confirmed-deliv-date';
import ProcessedBy from './processed-by';
import OrderRowAmount from './amount';
import Description from './description';
import IconButton from 'material-ui/IconButton';
import IconSendMsg from 'material-ui/svg-icons/communication/mail-outline';
import IconPreorder from 'material-ui/svg-icons/content/link';
import Preorder from './../order-row-preorder';
import IconPayment from 'material-ui/svg-icons/action/euro-symbol';
import IconEvents from 'material-ui/svg-icons/action/event';

const OrderRow = props => {
  const { order, order: { id }, rowsState, rowsShowPreorders, toggleRowState, toggleRowShowPreorders, togglePaymentConditions, toggleEvents } = props; //accessories, sets,
  const styles = OrderRow.prepareStyles();
  const {
    rowStyle,
    orderStatusOffer,
    orderStatusOrder,
    rowInnerStyle,
    firstColStyle,
    descrContainerStyle,
    qtyStyle,
    confirmedDelivDateStyle,
    processedByStyle,
    amountStyle,
    descriptionStyle,
    preorderRefStyle,
    iconStyle
  } = styles;

  return (
    <Paper className='orderRow' key={id} style={rowStyle}>
      {rowsShowPreorders[id] === true &&
        <Preorder {...props} key={id + 'foo'} rowsState={rowsState} isRef={true} />
      }
      {order.status === 1 &&
        <div style={orderStatusOffer}>
          <span style={{cursor: 'pointer'}}>
            Коммерческое предложение
          </span>
        </div>
      }
      {order.status === 2 &&
        <div style={orderStatusOrder}>
          <span style={{cursor: 'pointer'}}>
            Подтвержденный заказ
          </span>
        </div>
      }
      <div className='orderRowInner' style={rowInnerStyle}>
        <div className='orderMainProps' style={firstColStyle}>
          <OrderProps order={order} />
        </div>
        <div className='descrContainer' style={descrContainerStyle}>
          <div style={descriptionStyle}>
            <Description order={order} />
          </div>
          <div className='orderRowQtyColumn' style={qtyStyle}>
            <Qty order={order} />
          </div>
          <More className='orderRowMoreColumn' order={order} toggleRowState={toggleRowState} rowsState={rowsState} />
          <div style={confirmedDelivDateStyle}>
            <ConfirmedDelivDate order={order} />
          </div>
          <div style={amountStyle}>
            <OrderRowAmount order={order}/>
          </div>
          <div style={processedByStyle}>
            <ProcessedBy order={order}/>
          </div>
          <div>
            <IconButton
              onClick={
                e => {
                  toggleRowShowPreorders(id);
                }
              }
              style={preorderRefStyle}
              iconStyle={iconStyle}
            >
              <IconPreorder />
            </IconButton>
          </div>
          <div>
            <IconButton
              style={preorderRefStyle}
              iconStyle={iconStyle}
            >
              <IconSendMsg />
            </IconButton>
          </div>
          <div>
            <IconButton
              style={preorderRefStyle}
              iconStyle={iconStyle}
              onClick={
                () => {
                  togglePaymentConditions(order.id);
                }
              }
            >
              <IconPayment />
            </IconButton>
          </div>
          <div>
            <IconButton
              style={preorderRefStyle}
              iconStyle={iconStyle}
              onClick={
                e => {
                  toggleEvents(id);
                }
              }
            >
              <IconEvents />
            </IconButton>
          </div>
        </div>
      </div>
      {rowsState[id] &&
        <div>
          <div>
            { Object.keys(order.items).map( (key, i) => {
              if (i === 0) {
                return null;
              }
                return <ItemMore key={key} propKey={key} {...props} />;
            }) }
          </div>
        </div>
      }
    </Paper>
  )
}

OrderRow.prepareStyles = () => ({
  rowStyle: {
    display: 'flex',
    flex: '1 0 auto',
    flexDirection: 'column',
    padding: '4px',
    paddingLeft: '12px',
    marginBottom: '12px',
    position: 'relative',
    border: '1px solid #ddd'
  },
  rowInnerStyle: {
    display: 'flex',
    flex: '1 0 auto',
    alignItems: 'center',
    position: 'relative',
    height: '64px',
  },
  firstColStyle: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 150px',
    fontSize: '12px'
  },
  descrContainerStyle: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '800px'
  },
  qtyStyle: {
    display: 'flex',
    flex: '0 0 50px',
    fontWeight: 'bold',
  },
  confirmedDelivDateStyle: {
    display: 'flex',
    flex: '0 0 100px',
  },
  processedByStyle: {
    display: 'flex',
    flex: '0 0 100px',
  },
  amountStyle: {
    display: 'flex',
    flex: '0 0 100px',
    padding: '8px',
  },
  descriptionStyle: {
    display: 'flex',
    flex: '0 0 500px',
    padding: '8px',
  },
  preorderRefStyle: {
    // display: 'flex',
    // flex: '0 0 30px',
    padding: '4px',
    height: '32px',
    width: '32px'
  },
  iconStyle: {
    // padding: '0px',
    // height: '24px',
    // width: '24px'
  },
  orderStatusOrder: {
    position: 'absolute',
    right: '0px',
    top: '0px',
    // border: '1px solid #f44336',
    fontSize: '10px',
    color: '#f44336',
    borderRadius: '10px',
    padding: '4px',
    display: 'flex',
    cursor: 'pointer',
    fontWeight: 'bold'
  },
  orderStatusOffer: {
    position: 'absolute',
    right: '5px',
    top: '2px',
    // border: '1px solid #4CAF50',
    fontSize: '10px',
    color: '#4CAF50',
    borderRadius: '10px',
    padding: '4px',
    display: 'flex',
    cursor: 'pointer',
    fontWeight: 'bold'
  }
});

export default OrderRow;

// export default connect()(OrderRow);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/order-row-confirmed/index.js